<template>
  <div class="audio-item layout-flex layout-flex_v--c">
    <div v-if="isCanPlay" class="audio-play" >
      <img v-if="playStatus === 1" @click="handlePlay(0)" class="audio-play-btn" src="https://coolcdn.igetcool.com/p/2022/4/d52492fd0bed3318d91596763f50eadf.png?_60x60.png" alt="">
      <img v-else  @click="handlePlay(1)" class="audio-play-btn" src="https://coolcdn.igetcool.com/p/2022/4/6e37ad539c4916f01ded2b8f42bc8992.png?_60x60.png" alt="">
      <audio style="display: none;" :src="audio.audioUrl" preload="none" ref="audio"></audio>
    </div>

    <div class="audio-main layout-flex_block--1" @click.stop="handleListen">
      <div class="audio-name diandiandian-single">{{audio.audioTitle}}</div>
      <div class="audio-info layout-flex layout-flex_v--c">
        <span class="audio-info__tip" v-if="audio.audioFree === 1">试听</span>

        <span class="audio-info__time layout-flex_block--1">{{formatDuring(audio.audioDuration, '{h}时{m}分{s}秒')}} </span>
        <span class="audio-info__lock" v-if="!isCanPlay"></span>
        <span class="audio-info__read" v-if="isCanPlay && audio.docSwitch === 1" @click.stop="handleRead"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDuring, env, coolHref } from '@utils';

export default {
  name: 'SubsectionAudio',
  props: {
    audio: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      audioObj: null,
      playStatus: 0,  // 播放状态 0:暂停， 1:播放
    };
  },
  computed: {
    // 是否可播放
    isCanPlay() {
      return this.audio.audioFree === 1;
    }
  },
  methods: {
    // 转换音频时长
    formatDuring,
    // 播放、暂停
    handlePlay(status) {
      // if (env.isApp) {
      //   this.$emit('onJump', { data: this.audio, type: 1, index: this.index });
      //   return;
      // }

      let allAudio = document.querySelectorAll('audio');
      if (allAudio && allAudio.length) {
        allAudio.forEach(item => {
          item.pause();
        });
      }

      if (!this.audioObj) {
        // this.audioObj = new Audio(this.audio.audioUrl);
        this.audioObj = this.$refs.audio;
        this.audioObj.addEventListener('pause', (event) => {
          this.playStatus = 0;
        });
        this.audioObj.addEventListener('play', (event) => {
          this.playStatus = 1;
        });
      }
      if (status === 1) {
        this.audioObj.play();
      } else {
        this.audioObj.pause();
      }
      // this.playStatus = status;
    },
    // 设置播放状态
    // 读取文稿
    handleRead() {
      coolHref(this.audio.audioArticleUrl);
    },
    // 跳转到客户端
    handleListen() {
      if (this.isCanPlay) {
        this.handlePlay(this.playStatus === 1 ? 0 : 1);
      }
      this.$emit('onJump', { data: this.audio, type: 1, index: this.index });
    }
  }
};
</script>

<style lang="stylus" scoped>
.audio-item {
  padding: 16px 0 14px;
  &.active {
    .audio-name {
      color: #FF5F2E;
    }
  }
  .audio-play {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    &-btn {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .audio-main {
    width: 100px;
  }

  .audio-name {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3D3D4D;
    line-height: 20px;
  }

  .audio-info {
    margin-top: 4px;
  }
  .audio-info__tip {
    width: 26px;
    height: 13px;
    margin-right: 6px;
    text-align: center;
    line-height: 13px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    background: #FF5F2E;
    border-radius: 2px;
  }
  .audio-info__time {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A1A1B3;
    line-height: 16px;
  }
  .audio-info__read {
    width: 24px;
    height: 24px;
    background: url('https://coolcdn.igetcool.com/p/2022/4/766c3869ea8cc16235dbdd2665ffe072.png?_48x48.png') center center;
    background-size: contain;
  }
  .audio-info__lock {
    width: 24px;
    height: 24px;
    background: url('https://coolcdn.igetcool.com/p/2022/4/15783388e3b8c7fb5cac4171dcbb1ac1.png?_48x48.png') center center;
    background-size: contain;
  }
}
</style>